import { gql } from "@apollo/client";

/*
 * Every school, as the admin pages list them in their "School" dropdowns.
 *
 * `accountNumber` (the ACSI customer account number) is selected here and nowhere else: it exists so
 * admins can tell same-named schools apart, and it must never reach a report or a school user's view
 * (INC-25784). `src/pages/reports/account_number_masking.spec.ts` asserts that.
 */
export const ALL_SCHOOLS_QUERY = gql`
    query Schools {
        schools(order: name_ASC, first: 1000) {
            edges {
                node {
                    id
                    accountNumber
                    address
                    name
                }
            }
        }
    }
`;
